<ng-container *ngIf="dialogState === 'DEFAULT'">
    <h1 data-automation="deleteDialogHeader" mat-dialog-title>{{ 'baseline.dialog.delete.title' | translate }}</h1>
    <div mat-dialog-content>
        <p data-automation="dialogText">{{ 'baseline.dialog.delete.text' | translate }}</p>
    </div>
    <div mat-dialog-actions>
        <button
            class="x-btn-secondary dialog-secondary"
            aria-label="Cancel"
            (click)="onNoClick()"
            data-automation="dialogCancel"
        >
            <span> {{ 'baseline.button.cancel' | translate }}</span>
        </button>

        <button
            class="x-btn-primary dialog-primary"
            color="accent"
            aria-label="Delete"
            (click)="handleDelete()"
            data-automation="dialogDelete"
        >
            <span> {{ 'baseline.button.delete' | translate }}</span>
        </button>
    </div>
</ng-container>

<ng-container *ngIf="dialogState === 'DELETING'">
    <div mat-dialog-content>
        <div class="dialog-spinner">
            <div class="spinner-container">
                <mat-spinner diameter="24"></mat-spinner>
            </div>
            <span data-automation="dialogText">{{ 'baseline.dialog.delete.deleting' | translate }}</span>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="dialogState === 'DELETE_SUCCESS'">
    <div mat-dialog-content>
        <div class="dialog-result" data-automation="deleteResultModal">
            <mat-icon>check_circle</mat-icon>
            <span data-automation="deleteResultModalText">{{ 'baseline.dialog.delete.success' | translate }}</span>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="dialogState === 'DELETE_FAILED'">
    <div mat-dialog-content>
        <div class="dialog-result" data-automation="deleteResultModal">
            <mat-icon>warning</mat-icon>
            <span data-automation="deleteResultModalText">{{ 'baseline.dialog.delete.failed' | translate }}</span>
        </div>
    </div>
</ng-container>
